import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-or-later
import { useId } from 'react';
import { Input } from '../../primitives/Input.js';
import { describedBy, FieldHost } from '../FieldHost.js';
function asString(v) {
    return typeof v === 'string' ? v : '';
}
export function ShortText(props) {
    const { item, value, errors, disabled, onChange } = props;
    const id = useId();
    const current = asString(value);
    return (_jsx(FieldHost, { item: item, errors: errors, controlId: id, children: (ctx) => (_jsx(Input, { id: id, type: "text", value: current, disabled: disabled === true, maxLength: item.maxLength, required: item.required === true, "aria-invalid": ctx.hasError || undefined, "aria-describedby": describedBy(ctx), onChange: (e) => {
                const next = e.currentTarget.value;
                onChange(next === '' ? undefined : next);
            } })) }));
}
//# sourceMappingURL=ShortText.js.map